import { createClient } from '@supabase/supabase-js';
import { supabaseStatusStore } from '../utils/supabaseStatus.ts';
// Fallback showToast if not available
function showToast(message: string) {
  if (typeof window !== 'undefined') window.alert(message);
  else console.log('[TOAST]', message);
}

// Always use production Supabase (not local) since we have valid credentials
const supabaseUrl = import.meta.env.VITE_SUPABASE_URL;
const supabaseAnonKey = import.meta.env.VITE_SUPABASE_ANON_KEY;

console.info('[supabaseClient] Mode: PRODUCTION (Cloud-only)');
console.info('[supabaseClient] URL:', supabaseUrl);
console.info('[supabaseClient] Anon key:', supabaseAnonKey?.slice(0, 20), '...');

// Critical validation: Check if environment variables are missing or placeholder values
if (
  !supabaseUrl ||
  !supabaseAnonKey ||
  supabaseUrl.includes("your-project") ||
  supabaseAnonKey.startsWith("your-anon-key")
) {
  console.error("[supabaseClient] ❌ Detected placeholder Supabase credentials");
  console.error(`[supabaseClient] ❌ URL: ${supabaseUrl}`);
  console.error(`[supabaseClient] ❌ Key starts with: ${supabaseAnonKey?.slice(0, 15)}`);
  throw new Error("❌ CRITICAL: Placeholder Supabase credentials detected. Update environment variables with real values.");
}

// Confirm we're connecting to cloud (not local)
if (supabaseUrl?.includes('127.0.0.1') || supabaseUrl?.includes('localhost')) {
  throw new Error('❌ BLOCKING: Attempting to connect to local Supabase. Check environment variables.');
}

if (!supabaseUrl.includes('supabase.co')) {
  throw new Error('❌ BLOCKING: Supabase URL is not pointing to Supabase Cloud. Expected *.supabase.co');
}

console.info('✅ [supabaseClient] Confirmed: Connecting to Supabase Cloud');
console.info('✅ [supabaseClient] Project:', supabaseUrl.split('//')[1]?.split('.')[0]);

export const supabase = createClient(supabaseUrl, supabaseAnonKey);

supabase.auth.onAuthStateChange((event, _session) => {
  if (event === 'SIGNED_IN' || event === 'TOKEN_REFRESHED') {
    supabaseStatusStore.setOutage(false); // clear flag on successful refresh
  }
  if ((event as string) === 'TOKEN_REFRESH_FAILED') {
    console.warn('[Supabase] Token refresh failed — checking CORS / network');
    supabaseStatusStore.setOutage(true);
    showToast('⚠️ Supabase authentication failed. Please check your connection or try again later.');
  }
}); 